import { IWindowWithTrello } from "./trello";
import _getRestApi from "./_get-rest-api";

const API_KEY = process.env.API_KEY;
const APP_NAME = process.env.APP_NAME;

const useIframe = () => {
  const powerUp = (window as IWindowWithTrello).TrelloPowerUp;
  const trelloIFrame = powerUp.iframe({
    appKey: API_KEY,
    appName: APP_NAME,
  });
  trelloIFrame.getRestApi = () => _getRestApi(trelloIFrame);

  return trelloIFrame;
};

export default useIframe;
